import { gql } from '@apollo/client';

export const DECLINE_PENDING_QUOTES = gql`
  mutation declinePendingQuotes($request_id: String!) {
    declinePendingQuotes(requestUuid: $request_id) {
      complete
    }
  }
`;
